import { FC } from "react";
import { TextProps } from "./types";

const Text: FC<TextProps> = ({
  children,
  color,
  bold = false,
  size = 11,
  textStyles = {},
  className = "",
  props,
}) => {
  return (
    <p
      style={{
        color,
        fontSize: size,
        fontFamily: bold ? "IranSansBold" : "IranSansRegular",
        ...textStyles,
      }}
      className={className}
      {...props}
    >
      {children}
    </p>
  );
};

export default Text;
